// load-more-posts.js
// Alpine component for infinite scroll using IntersectionObserver

function revealCards(cards) {
    cards.forEach((card, index) => {
        card.style.animationDelay = `${index * 80}ms`;
        card.classList.add('card--visible');
        card.addEventListener('animationend', () => {
            card.style.willChange = 'auto';
        }, { once: true });
    });
}
window.revealCards = revealCards;

window.loadMorePosts = function () {
    return {
        loading: false,
        hasMore: false,
        page: 1,
        category: 0,
        tag: '',
        apiUrl: '',
        _observer: null,

        init() {
            this.hasMore   = this.$el.dataset.hasMore === 'true';
            this.page      = parseInt(this.$el.dataset.currentPage) || 1;
            this.category  = parseInt(this.$el.dataset.category) || 0;
            this.tag       = this.$el.dataset.tag || '';
            this.apiUrl    = this.$el.dataset.apiUrl || '';

            const existingCards = this.$refs.postsGrid.querySelectorAll('article.card');
            revealCards(existingCards);

            if (this.hasMore) {
                this._observer = new IntersectionObserver(
                    (entries) => {
                        if (entries[0].isIntersecting && !this.loading && this.hasMore) {
                            this.loadMore();
                        }
                    },
                    { rootMargin: '200px' }
                );
                this._observer.observe(this.$refs.sentinel);
            }
        },

        destroy() {
            if (this._observer) {
                this._observer.disconnect();
            }
        },

        async loadMore() {
            this.loading = true;
            this.page++;

            const params = new URLSearchParams({
                action: 'load_more_posts',
                page: this.page,
            });

            if (this.category) params.set('category', this.category);
            if (this.tag)      params.set('tag', this.tag);

            try {
                const existingCount = this.$refs.postsGrid.querySelectorAll('article.card').length;
                const response = await fetch(`${this.apiUrl}?${params}`);
                const data = await response.json();

                if (data.html && data.html.trim() !== '') {
                    this.$refs.postsGrid.insertAdjacentHTML('beforeend', data.html);
                    this.hasMore = data.has_more;

                    const allCards = this.$refs.postsGrid.querySelectorAll('article.card');
                    const newCards = Array.from(allCards).slice(existingCount);
                    revealCards(newCards);
                } else {
                    this.hasMore = false;
                }

                if (!this.hasMore && this._observer) {
                    this._observer.disconnect();
                }
            } catch (error) {
                console.error('Error loading posts:', error);
            } finally {
                this.loading = false;
            }
        },
    };
};
